//Author June Leow
//Date June 12th, 2024
import {getReducer, getSetStateFunction, getAPICallGenerator, postAPICallGenerator, putAPICallGenerator, deleteAPICallGenerator, callBackGenerator} from '../../util/util';
import {Card, CardHeader, CardBody, Row, Col, Input, Button} from 'reactstrap';
import {NavLink, useParams} from 'react-router-dom';
import React, {useReducer, useEffect} from 'react';
//initialize the state
const initialState = {
  valid: false
};

//reducer function that perform state update
const reducer = getReducer();


const GreenRenovationExp  = (props)=>{
  const controller = new AbortController();

  let id = useParams().id;
  let email = useParams().email;
  let expLevel = useParams().expLevel;
  let newInitialState = Object.assign({}, initialState, {
    id:id,
    expLevel:expLevel,
    email:email
  });

  const [state, dispatch] = useReducer(reducer,newInitialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const apiCallBack = callBackGenerator(setState);
  const httpPostNoToken = postAPICallGenerator(props, {signal:controller.signal, noToken:true});

  //run only once when component is loaded
  useEffect(()=>{
    updateProfile();
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state

  //API call
  const updateProfile=()=>{
    let parameters = [
      {
        field:'ID',
        value:state.id
      },
      {
        field:'email',
        value:state.email
      },
      {
        field:'expLevel',
        value:state.expLevel
      }
    ];

    const callBack = apiCallBack([{state:'valid', value:true}]);
    httpPostNoToken('appraiser/greenRenovationExp', parameters, 'Profile updated successfully.', 'Oops, something went wrong and could not update your profile. Please try again later.', callBack)
  }

  //render
  let action;

  if(!state.valid)
    action = <center>
      <b>Updating profile, please wait...</b><br/>
    </center>;
  else
    action = <center>
      Dear Valued @home VMS Appraiser,<br/><br/>Thank you for sharing your experience level on Green renovations appraisal. Your profile has been updated to reflect the answer given.
      <br/>If you have any questions or concerns, please email service@homevms.com or call us at 415-614-3880 so we can assist you.
      <br/>Thank you, and have a great day!
    </center>

  let topBar;
  let goBackLink;

  if(!props.isLoggedIn){
    topBar = <div className="topbar">
        <div className="topbar-logo-container">
          <NavLink to="/"><img className="topbar-logo-img" alt="@Home VMS Logo" width="120px" src="/img/logo_small.png"/></NavLink>
        </div>
    </div>;


  }
  else{
    goBackLink = <NavLink to={"/appraisal"}>Back to appraisal pipeline</NavLink>;
  }

  return (
    <div>
      {topBar}

      <div className="padding">
        <Row>
          <Col sm="1">

          </Col>
          <Col sm="10">
            {goBackLink}
            <Card style={{background:'#f5f5f5'}}>
              <CardHeader className="header-color">
                <center>
                    <i className="fa fa-edit"></i> Green Renovation Experience
                </center>
              </CardHeader>
              <CardBody>
                <div style={{background:'white', border:'1px solid #d2d2d2',padding:'5px',borderRadius:'5px'}}>
                  <br/>
                  {action}
                  <br/>
                </div>
                <br/>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}


export default GreenRenovationExp;
